import { createSelector } from 'reselect';

/**
 * Direct selector to the uiControl state domain
 */
const selectUiControlDomain = prop => state => state.get('uiControl').get(prop);

/**
 * Other specific selectors
 */

/**
 * Default selector used by UiControl
 */

const makeSelectUiControl = prop =>
  createSelector(
    selectUiControlDomain(prop),
    substate => substate && (substate.toJS ? substate.toJS() : substate),
  );

export default makeSelectUiControl;
export { selectUiControlDomain };
